// extracted by mini-css-extract-plugin
export var button = "protected-file-module--button--d2270";
export var loading = "protected-file-module--loading--84db2";